module.exports = __webpack_public_path__ + "static/media/correct.10737d28.mp3";